// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fiat-hold-banner {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  align-items: baseline;
  padding: 12px 16px;
  margin: 0 0 16px;
  border-radius: 12px;
  background: rgba(209, 170, 103, 0.12);
  border: 1px solid rgba(209, 170, 103, 0.4);
  color: #8a6a2a;
  font-size: 14px;
  line-height: 1.45;
}

.fiat-hold-banner strong {
  font-weight: 700;
}

body.light_theme .fiat-hold-banner,
.buy-sell-page .fiat-hold-banner {
  background: #fff8e8;
  border-color: #e6c98a;
  color: #6b5218;
}

.df-hero-content .fiat-hold-banner {
  background: rgba(209, 170, 103, 0.18);
  border-color: rgba(209, 170, 103, 0.5);
  color: #f3e0b0;
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/FiatHoldBanner/fiatHoldBanner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".fiat-hold-banner {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n  align-items: baseline;\n  padding: 12px 16px;\n  margin: 0 0 16px;\n  border-radius: 12px;\n  background: rgba(209, 170, 103, 0.12);\n  border: 1px solid rgba(209, 170, 103, 0.4);\n  color: #8a6a2a;\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.fiat-hold-banner strong {\n  font-weight: 700;\n}\n\nbody.light_theme .fiat-hold-banner,\n.buy-sell-page .fiat-hold-banner {\n  background: #fff8e8;\n  border-color: #e6c98a;\n  color: #6b5218;\n}\n\n.df-hero-content .fiat-hold-banner {\n  background: rgba(209, 170, 103, 0.18);\n  border-color: rgba(209, 170, 103, 0.5);\n  color: #f3e0b0;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
